export const GET_INGREDIENTS = "Ingredients/GET_INGREDIENTS";